export default __webpack_public_path__ + "i18n/bg.4bfae1f25675ac28fb27ddefa9bd8f6c.json";